<script lang="ts">
  export let color = "#1C1B1F";
  export let title = "Warnung";
</script>

<svg
  width="22"
  height="19"
  viewBox="0 0 22 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <title>{title}</title>
  <path
    d="M0 19L11 0L22 19H0ZM3.45 17H18.55L11 4L3.45 17ZM11 16C11.2833 16 11.521 15.904 11.713 15.712C11.9043 15.5207 12 15.2833 12 15C12 14.7167 11.9043 14.4793 11.713 14.288C11.521 14.096 11.2833 14 11 14C10.7167 14 10.4793 14.096 10.288 14.288C10.096 14.4793 10 14.7167 10 15C10 15.2833 10.096 15.5207 10.288 15.712C10.4793 15.904 10.7167 16 11 16ZM10 13H12V8H10V13Z"
    fill={color}
  />
</svg>
